<externos-header></externos-header>
<div class="bg-surface-secondary vh-100">
  <ng-content></ng-content>
</div>
